module.exports = __webpack_public_path__ + "static/media/arabic.dada74ec.dada74ec.png";